import { ReactElement, useCallback } from 'react';
import styles from '@/styles/pages/home/second-page.module.less';
import { useTranslation } from '@/services';
import { Button } from 'antd';
const EcologyPage = (): ReactElement => {
    const { t } = useTranslation('home', 'home.ecology');
    const ToWitePaper = useCallback(() => {
        const w = window.open('about:blank');
        if (w) {
            w.location.href = 'https://aicade-galaxy.gitbook.io/white-paper';
        }
    }, []);
    return (
        <div>
            <div className={styles['content']}>
                <div className={styles['content-bottom']}>
                    <ul className={styles['tags-style']}>
                        <ol className={styles['tab']}>
                            <div className={styles['title']}>{t('web-user-title')}</div>
                            <div className={styles['value']}>
                                <p>{t('web-user-value-1')}</p>
                                <p>{t('web-user-value-2')}</p>
                                <p>{t('web-user-value-3')}</p>
                            </div>
                        </ol>
                        <ol className={styles['tab']}>
                            <div className={styles['title']}>{t('player-title')}</div>
                            <div className={styles['value']}>
                                <p>{t('player-value-1')}</p>
                                <p>{t('player-value-2')}</p>
                                <p>{t('player-value-3')}</p>
                                <p>{t('player-value-4')}</p>
                            </div>
                        </ol>
                        <ol className={styles['tab']}>
                            <div className={styles['title']}>{t('author-title')}</div>
                            <div className={styles['value']}>
                                <p>{t('author-value-1')}</p>
                                <p>{t('author-value-2')}</p>
                                <p>{t('author-value-3')}</p>
                            </div>
                        </ol>
                        <ol className={styles['tab']}>
                            <div className={styles['title']}>{t('developer-title')}</div>
                            <div className={styles['value']}>
                                <p>{t('developer-value-1')}</p>
                                <p>{t('developer-value-2')}</p>
                            </div>
                        </ol>
                    </ul>
                    <Button onClick={() => ToWitePaper()} className={styles['button']}>
                        {t('button-name')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default EcologyPage;
